import { styled } from "styled-components";

import {
    colorCSS,
    cssColorsFromBackgroundField,
    fontSizes,
    radius,
    shadow
} from "../../styles";
import { redundantCssFromKebab } from "../../styles/redundant-css";

export const LinkItem = styled.button<{
    selected: boolean;
    accentColor?: string;
}>(
    {
        "borderRadius": radius.button,
        "border": 0,
        "height": "100%",
        "padding": "1rem",
        "position": "relative",
        "textAlign": "left",

        "h1, h2, h3, p": {
            fontSize: fontSizes.sm
        },

        "*:last-child": {
            marginBottom: 0
        },

        "> div": {
            height: "100%"
        }
    },
    ({ selected }) =>
        selected
            ? {
                  ...cssColorsFromBackgroundField({ color: "N0" }),
                  boxShadow: shadow.normal
              }
            : {
                  backgroundColor: "transparent",
                  color: "inherit"
              },
    ({ selected, accentColor }) =>
        selected &&
        accentColor && {
            "&:after": {
                backgroundColor: colorCSS(
                    accentColor === "Magenta"
                        ? "M100"
                        : `${accentColor.substring(0, 1)}200`
                ),
                borderRadius: `${radius.button} 0 0 ${radius.button}`,
                bottom: 0,
                content: '""',
                left: 0,
                position: "absolute",
                top: 0,
                width: "0.5rem"
            }
        },
    ({ accentColor }) =>
        accentColor && {
            paddingLeft: "1.5rem"
        }
);

//matches Carousel's padding
export const StackPadding = styled.div`
    ${redundantCssFromKebab("padding", "1rem 0")}
`;
